import React, { useEffect, useState } from "react";

import "./sidebar.css";

import logo from "../../assets/images/FPT_logo_2010.svg.png";

import SystemSidebar from "../../assets/JsonData/sidebar_routes.json";

import useAuth from "../../hooks/useAuth";

import SidebarItem from "./SidebarItem";
import { isAccessRoute } from "../../auth/ProtectedRoutes";
import { getSideBar } from "../../apis/shared.api";

const Sidebar = (props) => {
  const { pathname } = props.location;
  const { auth } = useAuth();

  const [listSideBar, setListSideBar] = useState([]);

  useEffect(() => {
    getSideBar((result) => {
      // * Supper admin not in department
      // * all user must include department
      result = [...SystemSidebar, ...result];

      if (auth.department) {
        result = result.filter(
          (sidebar) => sidebar.name.toUpperCase() !== "SYSTEM"
        );
      }

      setListSideBar([...result]);
    });
  }, [auth.id, auth.department]);

  return (
    <div className="sidebar">
      <div className="sidebar__logo">
        <img src={logo} alt="company logo" />
      </div>
      {listSideBar.map((item, index) =>
        auth?.id && isAccessRoute(auth?.permissions, item.permissions) ? (
          <SidebarItem key={index} item={item} sidePath={pathname} />
        ) : null
      )}
    </div>
  );
};

export default Sidebar;
